import * as React from 'react';

import { Box, Fullscreen, PublicThemeProvider } from '@numbox/components';
import { getFullYear } from '@numbox/util';

type Props = {
  banner?: React.ReactNode;
  children: React.ReactNode;
  layout?: 'prompt' | 'page';
};

export const PublicPage = ({ banner, children, layout = 'prompt' }: Props) => (
  <PublicThemeProvider>
    <Fullscreen
      backgroundColor="primary.main"
      color="primary.contrastText"
      sx={{
        backgroundColor: 'background.brand',
        backgroundAlignment: 'center',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundImage:
          // eslint-disable-next-line max-len
          'url(https://uploads-ssl.webflow.com/5d30f4524a82c62ac1e574c7/6529c37d675e9e3c349fbb32_numa_gradient_01.svg)',
      }}
      centered={layout === 'prompt'}
      disableScroll={layout === 'prompt'}
      layout="vertical"
    >
      {banner && <Box sx={{ width: '100%', marginBottom: 1 }}>{banner}</Box>}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        {children}
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'space-between',
          gap: 2,
          width: '100%',
          padding: 2,
          fontSize: 'caption.fontSize',
          '& a': {
            textDecoration: 'none',
            color: 'inherit',
          },
          '& a:hover': {
            textDecoration: 'underline',
          },
        }}
      >
        <Box>&#169; {getFullYear()} NumberAI, Inc.</Box>
        <a href="https://www.numa.com/legal/privacy">Privacy Policy</a>
      </Box>
    </Fullscreen>
  </PublicThemeProvider>
);
